import dayjs from "dayjs";

const PERCENT_STYLE_ENUM = {
    hidden: 'hidden',
    top: 'top',
    down: 'down'
}
const NARROW_MAP = {
    [PERCENT_STYLE_ENUM.top]:'https://s6.bihukankan.com/img/16912134522.png',
    [PERCENT_STYLE_ENUM.down]: 'https://s6.bihukankan.com/img/16912134451.png',
    [PERCENT_STYLE_ENUM.hidden] : ''
}
const VALUE_ERROR_MAP = {
    notVip: '****',
    notTime: '未满时,请等待',
    noChange: '无明显变动'
}
const VALUE_STYLE_MAP = {
    default: 'default',
    noValue: 'noValue'
}
const VALUE_KEY_MAP = {
    2: 'sales2Hours',
    24: 'sales24Hours'
}
const STOP_TIME_KEY_MAP = {
    2:'stopTimeOver2Hours',
    24:'stopTimeOver24Hours'
}
export default {
    props: {
        date:{ type:String, default : '' }, // 时间
        data:{ type:Array, default: () => ([]) }, // 直播列表数据
    },
    data: () => ({
        NARROW_MAP,
        PERCENT_STYLE_ENUM,
        VALUE_ERROR_MAP,
        livingSales: 0, // 直播销售额
        apiData:null
    }),
    computed: {
        notYearVip: (_this = this) =>
            !_this.$store.state.userLevel ||
            _this.$store.state.userLevel && _this.$store.state.userLevel > 94,

        twoHour: (_this = this) => _this.getValue(2),
        twentyFourHour: (_this = this) => _this.getValue(24),
    },
    watch:{
        '$props.data':{
            immediate: true,
            handler(data) {
                this.comOriginData(data)
            }
        },
        '$props.date':{
            immediate: true,
            handler() {
                this.getData()
            }
        },
    },
    methods: {
        getData(){
            const anchorId = this.$route.params?.id
            const date1 = dayjs(this.$props.date,'YYYYMMDD').startOf('days').unix()
            const date2 = dayjs(this.$props.date,'YYYYMMDD').endOf('days').unix()
            const time = `{$between:[${date1},${date2}]}`
            this.$api.get(`/v1.1.0/gifshow/anchor/${anchorId}/liveStreamTraceStatistic`,{
                params: { time }
            }).
            then(res => this.apiData = res)
        },
        comOriginData(data){
            let livingSales = 0
            data?.forEach(ele => {
                livingSales += isNaN(Number(ele?.sales)) ? 0 : Number(ele?.sales)
            })
            this.$data.livingSales = livingSales
        },
        /** 检测距今时长符合要求 */
        checkDuring(hour){
            const stopKey = STOP_TIME_KEY_MAP[hour]
            return !!this.$data.apiData?.[stopKey]
        },
        /** 计算Value */
        comValue(hour){
            const key = VALUE_KEY_MAP[hour]
            const value = this.$data.apiData?.[key] && Number(this.$data.apiData?.[key]) >= 0 ? this.$data.apiData?.[key] : null
            const base = Number(this.$data.livingSales)
            const during = value - base
            if(this.notYearVip) return { value: VALUE_ERROR_MAP.notVip, valueStyle: VALUE_STYLE_MAP.noValue}
            if(!this.checkDuring(hour)) return { value: VALUE_ERROR_MAP.notTime, valueStyle: VALUE_STYLE_MAP.noValue}
            if(during > 0) return { value:VALUE_ERROR_MAP.noChange, valueStyle: VALUE_STYLE_MAP.noValue } // 增长文字
            return {
                value: '¥' + this.$retainWan(value,2,false,'--'),
                valueStyle:VALUE_STYLE_MAP.default
            }
        },
        /** 计算百分比 */
        comPercent(hour) {
            const key = VALUE_KEY_MAP[hour]
            const base = Number(this.$data.livingSales)
            const value = Number(this.$data.apiData?.[key])
            const check = this.checkDuring(hour)
            if(this.notYearVip) return { percentValue: '****%', percentStyle: PERCENT_STYLE_ENUM.top }
            if(
                isNaN(base) ||
                isNaN(value) ||
                base === 0 ||
                !check ||
                !value ||
                value && value < 0
            ) return { percentValue: '--%', percentStyle: PERCENT_STYLE_ENUM.hidden }
            const during = value - base
            const narrow = during  > 0
            if(narrow) return { percentValue:'', percentStyle: PERCENT_STYLE_ENUM.hidden } // 增长不显示
            const percentValue = (during * 100 / base).toFixed(2) + '%'
            return { percentValue, percentStyle: narrow ? PERCENT_STYLE_ENUM.top: PERCENT_STYLE_ENUM.down }
        },
        /** 计算value */
        getValue(hour){
            let {value,valueStyle} = this.comValue(hour)
            let { percentValue,percentStyle } = this.comPercent(hour)
            return {
                value,
                valueStyle,
                percentValue,
                percentStyle
            }
        },
        goToOpenVIP() {
            this.$router.push({
                path: '/dredgeVip',
                query: {
                    unSelect: Object.keys(this.$store.state.yearVipOnly || {}).toString(),
                    road: location.href
                }
            })
            this.$store.commit('WRITEOVERLAYSHOW', { status: false })
        }
    }
}
